export default "__VITE_ASSET__DxWWMnYl__"